// ChatGameCard.jsx — pure game renderer.
// Receives sessionId + gameType from parent (ChatConversation).
// No invite/accept/decline logic here.

import Hangman      from './games/Hangman';
import OneWordStory from './games/OneWordStory';

export default function ChatGameCard({ sessionId, gameType, myPlayerId, otherPlayerId, onBack, onRestart }) {
  if (!sessionId || !gameType) return null;

  const props = { sessionId, myPlayerId, otherPlayerId, onBack, onRestart };

  if (gameType === 'hangman')   return <Hangman      {...props} />;
  if (gameType === 'story')     return <OneWordStory {...props} />;

  return (
    <div style={{ padding: 16, color: '#888', textAlign: 'center' }}>
      Unknown game type: {gameType}
    </div>
  );
}
